import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from '@thd-olt-component-react/router';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { EXP_ROUTES, JOB_POSTING_STATUS } from '../../../utils/constants';
import { capitalizesFirstLetters } from '../../../utils/formatters';

const PublishJobPostingDialog = ({ creatingJobPosting = false }) => {
  const {
    jobPostingStore: {
      togglePublishJobPostingModal,
      pendingPublishingJobPosting,
      saveJobPosting: saveJobPostingStore
    }
  } = useStore();

  const {
    saveJobPosting,
    editedJobPosting
  } = useContext(JobPostingContext);

  const navigate = useNavigate();

  const handleClose = (jobPostingId) => {
    togglePublishJobPostingModal();
    if (jobPostingId !== undefined) {
      window.setTimeout(() => {
        navigate(EXP_ROUTES.JOB_POSTING(jobPostingId));
      }, 100);
    } else {
      navigate(EXP_ROUTES.JOB_POSTINGS);
    }
  };

  const composeDataForSubmit = (status) => {
    return {
      ...editedJobPosting,
      companyUrl: editedJobPosting.companyUrl || null,
      sharing: true,
      status,
      title: capitalizesFirstLetters(editedJobPosting.title)
    };
  };

  return (
    <ConfirmDialog
      headerText="Publish Job Posting"
      open={!!pendingPublishingJobPosting}
      onConfirm={() => {
        if (creatingJobPosting) {
          saveJobPostingStore(composeDataForSubmit(JOB_POSTING_STATUS.ACTIVE), handleClose);
        } else {
          saveJobPosting(true);
        }
      }}
      onClose={() => {
        togglePublishJobPostingModal();
      }}
      confirmTestId="confirm-publish-job-posting"
      confirmText="Publish Posting"
      cancelText="Cancel"
    >
      Publish this posting to activate your job!
      <br />
      When you click “Publish Posting”, your job posting will become visible to candidates, and
      candidates will be able to apply.
      <br />
      You also be given a list of recommended candidates, whose qualifications best match your job
      requirements. Visit “Recommended for You” and click “Invite” to encourage these candidates to
      apply.
    </ConfirmDialog>
  );
};

export default observer(PublishJobPostingDialog);
